import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import horizontal_blue_bar from '../../assets/images/horizontal_blue_bar.png';
import dots_rect from '../../assets/images/dots_rect.png';
import address from '../../assets/images/address.png';
import phone from '../../assets/images/phone.svg';
import whatsapp from '../../assets/images/whatsapp.png';
import email from '../../assets/images/email.png';
import branch from '../../assets/images/branch.png';
import mumbai from '../../assets/City Icons/Mumbai.png';
import meerut from '../../assets/City Icons/Meerut augarnath Temple.png';
import kolhapur from '../../assets/City Icons/Kolhapur - Shahu palace.png';
import assam from '../../assets/City Icons/Assam Kakochang Waterfalls.png';
import ahemdabad from '../../assets/City Icons/Ahmedbad - Statue of Unity.jpg';
import ludhiana from '../../assets/City Icons/Punjab - Golden Temple.png';
import pune from '../../assets/City Icons/Pune.jpg';
import bikaner from '../../assets/City Icons/Bikaner fort.jpg';
import himachal from '../../assets/City Icons/Himachal mountain.png';
import howrah from '../../assets/City Icons/Howrah Bridge Kolkata.jpg';
import jaipur from '../../assets/City Icons/Jaipur hawa-mahal.png';
import rajkot from '../../assets/City Icons/Rajkot Museum.jpg';
import surat from '../../assets/City Icons/Surat castle.png';
import patna from '../../assets/City Icons/Patna planetarium.png';
import mp from '../../assets/City Icons/Holkar stadium MP.png';
import { BACKEND_URL } from 'utils/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const ContactUs = () => {
  const branchOfficeArray = [
    {
      name: 'Pune (ROM)',
      address:
        'Office No - 308, 3rd Floor, Millennium Star, Dhole Patil Road, Pune - 411001',
      mobileNo: 'https://goo.gl/maps/WUZMpMohH7U17R2a8      ',
      email: pune,
    },
    {
      name: 'Sangli',
      address:
        'Plot No - 23, Yojana Bhavan, Madhavnagar Road, Sangli Maharashtra - 416416',
      mobileNo: 'https://goo.gl/maps/TRRifDhNYRwNzBnN9      ',
      email: branch,
    },
    {
      name: 'Kolhapur',
      address:
        'Office No 1,2 & 3, First Floor, Swastik House, 768 / A, E Ward Shahupuri 4th Lane, Kolhapur - 416001',
      mobileNo: 'https://goo.gl/maps/bx176JXYDbNLmVBQ7      ',
      email: kolhapur,
    },
    {
      name: 'Delhi ',
      address:
        'Office No - 1452, 14th Floor, Aggrawal Metro Heights, Netaji Subhash Place, Delhi - 110034',
      mobileNo: 'https://goo.gl/maps/KEshYTFGjgMG31JU8      ',
      email: branch,
    },
    {
      name: 'Ludhiana (Punjab)',
      address:
        'Office No 305, SCO-15, Sun Plaza Building, Above IDFC Bank, Feroze Gandhi Market, Ludhiana - 141001.',
      mobileNo: 'https://goo.gl/maps/wViys9YDecQZ5FaK8      ',
      email: ludhiana,
    },
    {
      name: 'Kangra (Himachal Pradesh)',
      address:
        'Shop No.1, Bassa Chowk, near Shiv Mandir, Tehsil Jawali, Dist Kangra 176027 ',
      mobileNo: 'https://maps.app.goo.gl/Dn2P7ayqipHS2ef19',
      email: himachal,
    },
    {
      name: 'Jaipur (Rajsthan)',
      address:
        '201 A- 2nd floor Shyam Anukampa Ashok Marg C-Scheme - Jaipur – 302016, Rajasthan',
      mobileNo: 'https://goo.gl/maps/pG1QfL7LJSUTAGYt5      ',
      email: jaipur,
    },
    {
      name: 'Bikaner (Rajashtan)',
      address:
        '1st Floor, Paras Complex, Near Chopra Katla, Rani Bazaar, Bikaner - 334001',
      mobileNo: 'https://goo.gl/maps/voaEAjrEqx7FHCMd6      ',
      email: bikaner,
    },

    {
      name: 'Lucknow (Uttar Pradesh)',
      address:
        'D-301, 2nd Floor, Govinda Apartment, Opp Saharaganj & SSP Office, Hazratganj, Lucknow - 226001',
      mobileNo: 'https://goo.gl/maps/AM413NajLb2ChN2c9      ',
      email: branch,
    },

    // {
    //   name: 'Patna ( Bihar )',
    //   address:
    //     'Office No 114, Ground Floor, NRI Plaza, Rajeev Nagar Main Road, Patna, Bihar - 800024',
    //   mobileNo: 'https://goo.gl/maps/vrETwhbneJ1V68ro6      ',
    //   email: patna,
    // },
    {
      name: 'Ahmedabad (Gujarat)',
      address:
        'Abhijeet - 3, Office No. 203, Above Pantaloon Showroom, Near Mithakhali Six Road, Law Garden, Ahmedabad, Gujarat - 380006',
      mobileNo: 'https://goo.gl/maps/BNbv7zBz58PpVg2u6      ',
      email: ahemdabad,
    },
    {
      name: 'Rajkot (Gujarat)',
      address:
        'Level 6, Office No - 429, Opp Imperial Heights, 150 feet Ring Road, Rajkot, Gujarat - 360005',
      mobileNo: 'https://maps.app.goo.gl/LmoKYBUUFSMWWZr59',
      email: rajkot,
    },

    {
      name: 'Indore (Madhya Pradesh)',
      address: '123, Bansi Trade Centre, 581/5 M G Road, Indore - 452001',
      mobileNo:
        'https://www.google.com/maps/search/123,+Bansi+Trade+Centre,+581%2F5+M+G+Road,+Indore+-+452001/@22.7230547,75.8794589,17z/data=!3m1!4b1?entry=ttu',
      email: mp,
    },
    {
      name: 'Bhopal (Madhya Pradesh)',
      address: 'Hotel Mayuri, 32 Zone - 2, M.P Nagar, Bhopal – 46201',
      mobileNo: 'https://maps.app.goo.gl/6KMBfoz7UT4Y1SnT6',
      email: mp,
    },
    // {
    //   name: 'Kolkatta',
    //   address:
    //     'New B.K Market, 16A Shakespeare Sarani, 1st Floor, Office Number 20 & 24, Opp Nightingale Hospital, Kolkata - 700017',
    //   mobileNo: 'https://goo.gl/maps/YRqHhf2ypAvtrHX39      ',
    //   email: howrah,
    // },
  ];

  // State for form inputs
  const [formData, setFormData] = useState({
    name: '',
    mobile_no: '',
    email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [debouncedValue, setDebouncedValue] = useState({});

  // Debounce delay time (in ms)
  const debounceDelay = 500;

  // Regex patterns for validation
  const nameRegex = /^[A-Za-z\s]*$/; // Allow only letters and spaces
  const mobileRegex = /^[0-9]{0,10}$/; // Allow only numbers (up to 10 digits)
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Basic email validation pattern

  // Handle input change with debounce
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Update the input value immediately
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Set the debounced value after a delay
    setDebouncedValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Debouncing logic using useEffect to validate after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      validateInput(debouncedValue);
    }, debounceDelay);

    return () => clearTimeout(timer); // Clean up the timer
  }, [debouncedValue]);

  // Validate input fields
  const validateInput = (values) => {
    let validationErrors = {};
    // Validate each field after debouncing
    if (values.name && !nameRegex.test(values.name)) {
      validationErrors.name = 'Name must contain only letters and spaces.';
    }
    if (values.mobile_no && !mobileRegex.test(values.mobile_no)) {
      validationErrors.mobile_no = 'Mobile number must be up to 10 digits.';
    }
    if (values.email && !emailRegex.test(values.email)) {
      validationErrors.email = 'Invalid email format.';
    }

    setErrors(validationErrors);
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Make the POST request to the backend
      const response = await axios.post(
        `${BACKEND_URL}ieadmin/connect_us/`,
        formData
      );
      toast.success(`${response.data.message}`, {
        position: 'top-right', // Set the position of the toast
        autoClose: 3000, // Auto-close after 3 seconds
      });
      setFormData({
        name: '',
        mobile_no: '',
        email: '',
        message: '',
      });
    } catch (error) {
      // Handle error
      console.error('Error submitting form:', error);
      toast.error(`${error.error}`, {
        position: 'top-right', // Set the position of the toast
        autoClose: 3000, // Auto-close after 3 seconds
      });
    }
  };

  const formRef = useRef(null);
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  // GSAP Animations
  useEffect(() => {
    const tl = gsap.timeline();
    // Animate form from left and inputs from top
    gsap.from(formRef.current, {
      x: -200, // Slide in from left
      opacity: 0,
      duration: 1.2,
      ease: 'power3.out',
    });

    gsap.from(formRef.current.querySelectorAll('input, textarea'), {
      y: -100, // Inputs come from the top
      opacity: 0,
      stagger: 0.2,
      duration: 0.8,
      ease: 'power3.out',
    });

    // Animate section from right and elements from top
    gsap.from(sectionRef.current, {
      x: 200, // Slide in from right
      opacity: 0,
      duration: 1.2,
      ease: 'power3.out',
    });

    gsap.from(sectionRef.current.querySelectorAll('img, .text-xs'), {
      y: -100, // Text elements come from the top
      opacity: 0,
      stagger: 0.2,
      duration: 0.8,
      ease: 'power3.out',
    });

    // Animate cards on scroll one by one from top
    cardRefs.current.forEach((card, index) => {
      gsap.from(card, {
        scrollTrigger: {
          trigger: card,
          start: 'top 80%', // Animation starts when the card reaches 80% from top of viewport
          toggleActions: 'play none none none',
        },
        y: -100,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
      });
    });
    return () => {
      tl.kill(); // Stop the animations
    };
  }, []);

  return (
    <div className="w-full mt-8">
      <ToastContainer />
      <section
        className="flex flex-col md:flex-row py-8 px-8 md:px-12 lg:px-24 md:gap-x-6 lg:gap-x-12 gap-y-4 md:gap-y-0 "
        ref={formRef}
      >
        <div className="w-full md:w-1/2 shadow-lg p-4 rounded-lg flex-col ">
          <h2 className="text-lg md:text-3xl w-full md:w-3/4 m-auto text-slate-500 font-bold">
            Contact Us
          </h2>
          <p>
            <p className="w-full md:w-3/4 m-auto">
              <hr className="w-20 md:w-36 border-2 border-orange-500 my-1" />
            </p>
          </p>
          <p className="text-xs md:text-sm font-semibold text-slate-500 w-full md:w-3/4 m-auto">
            Reach out for any insurance inquiries or assistance
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-y-8 mt-8">
            {['name', 'mobile_no', 'email'].map((field) => (
              <div className="relative w-full md:w-3/4 m-auto" key={field}>
                {/* Wrapper for input and orange line */}
                <div className="relative">
                  <input
                    name={field}
                    placeholder={
                      field.charAt(0).toUpperCase() +
                      field.slice(1).replace('_', ' ')
                    }
                    value={formData[field]}
                    onChange={handleChange}
                    type={field === 'email' ? 'email' : 'text'}
                    className={`w-full border-b-[1px] border-slate-300 focus:outline-none text-sm md:text-base ${
                      errors[field] ? 'border-red-500' : ''
                    }`}
                    onFocus={(e) =>
                      e.target.nextSibling.classList.remove('scale-0')
                    }
                    onBlur={(e) => {
                      if (!e.target.value)
                        e.target.nextSibling.classList.add('scale-0');
                    }}
                  />
                  {/* Orange bottom border with animation */}
                  <span className="w-full absolute left-0 right-0 bottom-0 border-b-[2px] border-orange-500 transition-all duration-300 origin-left scale-0" />
                </div>
                {/* Error message */}
                {errors[field] && (
                  <p className="text-red-500 text-xs mt-1">{errors[field]}</p>
                )}
              </div>
            ))}

            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="w-full md:w-3/4 border-b-[1px] border-slate-300 focus:outline-none focus:border-orange-500 focus:border-b-[2px] m-auto text-sm md:text-base"
              rows={5}
              maxLength={150}
            />
            <p className="text-xs text-slate-500 mt-1">
              {formData.message.length}/150
            </p>

            <div className="flex justify-center md:flex-none">
              <button
                type="submit"
                className="h-8 w-min bg-gradient-to-r from-blue-900 to-blue-300 px-8 py-2 rounded-xl text-white text-sm hover:from-blue-300 hover:to-blue-900 duration-700"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>

        <div
          className="w-full md:w-1/2 flex flex-col gap-y-4 rounded-lg"
          ref={sectionRef}
        >
          <div className="relative w-full h-[400px] md:h-full mb-4">
            <div className="absolute  w-full h-full rounded-lg shadow-lg ">
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29325.20477448057!2d72.82196821029851!3d19.223615093110947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b1ed8c12ef13%3A0x39f3e888d0b7293a!2sNavkar%20Paradise%20A%20wing!5e0!3m2!1sen!2sin!4v1746881329315!5m2!1sen!2sin"
                className="w-full h-full rounded-lg "
                style={{ border: '0' }}
                allowFullScreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div className="w-full flex gap-2 border-[1px] border-slate-300 p-1 rounded-lg items-center justify-start">
            <img src={address} alt="" className="w-5 h-6 " />
            <div className="text-xs md:text-base font-bold text-slate-500">
              Address:
              <span className="font-normal text-xs md:text-base text-slate-400">
                Office No. 28, Second Floor, Navkar Paradise, L T Road, Babhai
                Naka, Borivali West, Mumbai - 400092
              </span>
            </div>
          </div>
          <div className="w-full flex gap-2 border-[1px] border-slate-300 p-2 rounded-lg items-center justify-start">
            <img src={whatsapp} alt="" className="w-5 h-5 " />
            <div className="text-xs md:text-base font-bold text-slate-500">
              Whatsapp :
              <span className="font-normal text-xs md:text-base text-slate-400">
                +91 74000 63232
              </span>
            </div>
          </div>
          <div className="w-full flex gap-2 border-[1px] border-slate-300 p-2 rounded-lg items-center justify-start">
            <img src={phone} alt="" className="w-3 h-3 md:w-5 md:h-5 " />
            <div className="text-xs md:text-base font-bold text-slate-500">
              Call (Toll Free) :
              <span className="font-normal text-xs md:text-base text-slate-400 mr-3">
                1800 267 8949
              </span>
            </div>
          </div>
          <div className="w-full flex gap-2 border-[1px] border-slate-300 p-2 rounded-lg items-center justify-start">
            <img src={email} alt="" className="w-3 h-2 md:w-4 md:h-3 " />
            <div className="text-xs md:text-base font-bold text-slate-500">
              Email :
              <span className="font-normal text-xs md:text-base text-slate-400">
                enquiry@insureefficient.com
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="py-8 px-12 md:px-16 lg:px-24">
        <div className=" text-lg md:text-3xl text-slate-500 font-bold px-5 text-center md:text-left">
          You can find us at
        </div>
        <hr className="w-36 md:w-60 border-2 border-orange-500 my-1 md:mx-5 m-auto" />
        <div className="flex flex-row flex-wrap gap-x-12 gap-y-6 justify-center mt-8">
          {branchOfficeArray.map((item, index) => (
            <a
              href={item.mobileNo}
              target="_blank"
              rel="noreferrer "
              key={index.toString()}
              ref={(el) => (cardRefs.current[index] = el)}
              className="w-64 h-auto bg-white rounded-lg flex flex-col justify-center items-center text-center flex-initial p-4 shadow-lg gap-y-2 hover:scale-110 duration-500 cursor-pointer"
            >
              <img
                src={item.email}
                alt=""
                className="w-32 h-20"
                style={{ objectFit: 'contain' }}
              />
              <p className="font-bold text-md text-slate-500">{item.name}</p>
              <p className="font-semibold text-xs text-slate-400">
                {item.address}
              </p>
              {/* {item.email && <p>E: {item.email}</p>} */}
              <a href={item.mobileNo} target="_blank" rel="noreferrer">
                <button className="uppercase bg-[#1976D2] hover:bg-[#1996D2] text-xs text-white rounded-lg w-max py-1 px-5">
                  Locate Us
                </button>
              </a>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
